

// @ts-ignore
import { defineStore } from "pinia";
import { ApiUser } from "@/api/login";
import { ApiAuth } from "@/api/auth";
import { AiToolLink } from "@/utils/config";
import { sortAndEncrypt } from "@/utils/login";
import router, { isMobile } from "@/router/index";



const userStore = defineStore("userStore", {
  state: () => ({
    token: null as string | null,
    userinfo: {
      userId: null,
      nickName: "",
      avatar: "",
    },
    chatbotToken: "",
    dialogLogin: false,
  }),
  getters: {
    isLogined: (state) => state.token !== null && state.token.trim() !== "",
  },
  actions: {
    login() {
      if (isMobile()) {
        router.push("/mobile/login");
      } else {
        this.dialogLogin = true;
      }
    },
    loadUserInfo() {
      if (!this.token) return;
      ApiUser.getUserInfoApi(sortAndEncrypt()).then((res: any) => {
        if (res && res.code == 200) {
          this.userinfo.userId = res.data.userId;
          this.userinfo.nickName = res.data.nickName;
          this.userinfo.avatar = res.data.avatar;
          localStorage.setItem("AI-UserId", res.data.userId);
          
        } else {
          this.logout();
          this.login();
        }
      });
      ApiAuth.apiGetUserAuth().then(async (res: any) => {
        
        if (res.code === 200) {
          this.chatbotToken = res.data.chatbotToken;
          localStorage.setItem("AI-chatbotToken", res.data.chatbotToken);
        }
      })
      ApiAuth.apiGetUserRoles({sessionId: this.token}).then(async (res: any) => {
        if (res.code === 200) {
          // localStorage.setItem("isOuterUser", res.data.isCollegeContestUser);
          let list = res.data.list || [];
          let innerId = import.meta.env.MODE === "production" ? 5 : 35;
          let displayId = import.meta.env.MODE === "production" ? 28 : 60;
          //判断roles中元素是否包含id为5的元素
          let isInnerUser = list.some((item) => item.roleId === innerId);
          localStorage.setItem("isOuterUser", !isInnerUser); //默认外部用户
          let isDisplayUser = list.some((item) => item.roleId === displayId);
          localStorage.setItem("isDisplayUser", isDisplayUser);
        }
      })
    },
    logout() {
      this.token = null;
      this.userinfo = {
        userId: null,
        nickName: "",
        avatar: "",
      };
      localStorage.removeItem("AI-Token");
      localStorage.removeItem("AI-UserId");
      localStorage.removeItem("isOuterUser");
      
    },
    setup() {
      this.token = localStorage.getItem("AI-Token") || "";
      this.loadUserInfo();

    },
  },
  // persist: {
  //   storage: persistedState.localStorage,
  // },
});

export default userStore;
